var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5636 34.8712C27.1407 34.8712 34.9045 27.0969 34.9045 17.5068C34.9045 7.91666 27.1407 0.142334 17.5636 0.142334C7.98646 0.142334 0.222656 7.91666 0.222656 17.5068C0.222656 27.0969 7.98646 34.8712 17.5636 34.8712Z",
    fill: "#4DAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6775 7.44189C12.0393 7.44189 7.45703 12.0304 7.45703 17.6762C7.45703 19.9128 8.17449 21.9868 9.3996 23.6745L8.12711 27.4768L12.0529 26.2161C13.6705 27.287 15.5996 27.9105 17.6775 27.9105C23.3157 27.9105 27.898 23.322 27.898 17.6762C27.8912 12.0304 23.3089 7.44189 17.6775 7.44189ZM23.6203 21.8919C23.3766 22.59 22.3951 23.1661 21.6168 23.3356C21.0821 23.4508 20.3849 23.5389 18.0362 22.5629C15.031 21.3158 13.0952 18.2591 12.9463 18.0625C12.8042 17.866 11.7347 16.4427 11.7347 14.9787C11.7347 13.5147 12.4793 12.7963 12.7771 12.4913C13.0208 12.2405 13.4336 12.1253 13.8194 12.1253C13.948 12.1253 14.0563 12.1321 14.1646 12.1388C14.4624 12.1524 14.6181 12.1727 14.8144 12.6472C15.0581 13.2436 15.6605 14.7076 15.7349 14.8635C15.8094 15.0126 15.8838 15.2159 15.7755 15.4192C15.6808 15.6226 15.5928 15.7175 15.4439 15.8869C15.295 16.0631 15.1528 16.1919 14.9972 16.3817C14.8618 16.5443 14.7061 16.7206 14.8753 17.0188C15.0513 17.3102 15.6469 18.293 16.5336 19.0792C17.6775 20.0958 18.598 20.4212 18.9297 20.5567C19.1733 20.6584 19.4711 20.6381 19.6471 20.4415C19.8773 20.1975 20.1615 19.7841 20.4458 19.3842C20.6489 19.0927 20.9061 19.0589 21.1768 19.1605C21.4543 19.2554 22.9163 19.9806 23.2141 20.1297C23.512 20.2788 23.715 20.3534 23.7827 20.4822C23.8707 20.5974 23.8707 21.1938 23.6203 21.8919Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhIcon);
export default __webpack_public_path__ + "static/media/wh-icon.de8db1ed64c5dfe15776f9f19328746c.svg";
export { ForwardRef as ReactComponent };